module.exports = __webpack_public_path__ + "img/figure-2.284d4468.png";